import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useAbstractCreate } from '@/module/Author/Abstract/model/AbstractQuery';
import { AbstractSchema, abstractSchema, defaultAbstractValues } from '@/module/Author/Abstract/model/AbstractSchema';
import { Abstract } from '@/module/Author/Abstract/model/AbstractTypes';
import { ImportItem } from '@/module/Sync/model/SyncTypes';

import { dangerouslyConvertType, useAppNotification } from '@feature/utils';

import { AbstractForm } from './AbstractForm';

interface AbstractSyncProps {
  onSuccess: (abstract: Abstract) => void;
  item: ImportItem;
  onCancel: () => void;
  sourceType: string;
}

function convert(item: ImportItem, sourceType: string): AbstractSchema {
  return dangerouslyConvertType<AbstractSchema>({
    ...item,
    bdis: [],
    wosCategories: [],
    wosIndexes: [],

    language: null,
    sourceType,
  });
}

export function AbstractSync({ onSuccess, item, onCancel, sourceType }: AbstractSyncProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useAbstractCreate();
  const notification = useAppNotification();

  const onSubmit = (values: AbstractSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newAbstract => {
        notification.success();
        onSuccess(newAbstract);
      },
    });
  };

  return (
    <>
      <Text>{item.journalName}</Text>
      <AbstractForm
        title={t('abstracts.form.title.create')}
        schema={abstractSchema}
        defaultValues={defaultAbstractValues}
        values={convert(item, sourceType)}
        isSubmitting={isPending}
        isError={isError}
        isSuccess={isSuccess}
        onSubmit={onSubmit}
        onCancel={onCancel}
        showWosFields={false}
        showScopusFields={false}
      />
    </>
  );
}
